export const URL_DRINK = "/drinks/"
export const URL_DRINK_BY_ID = (id) => {
    return `/drinks/${id}/`
}
export const URL_DRINK_BY_SEANCE = (id) => {
    return `/drinks/?seance=${id}`
}
export const URL_DRINK_ANONYMOUS_SORTED_BY_CAT_BY_SEANCE = (id) => {
    return `/drinks_anonymous/seance/by_category/${id}/`
}
export const URL_LOGIN = "/token/";
export const URL_REGISTER = "/register/";
export const URL_LOGIN_FROM_ADMIN_BACKOFFICE = "/token-from-admin-backoffice/"
export const URL_LOGOUT = "/token/delete/";
export const URL_TOKEN_REFRESH = "/token/refresh/"
export const URL_ME = "/me/"
export const URL_SUBSCRIPTION = (id) => {
    return `/subscriptions/${id}/`
}
export const URL_REQUEST_RESET_PASSWORD = "/request-reset-password/"
export const URL_RESET_PASSWORD = (id, token) => {
    return `/reset-password/${id}/${token}/`
}
export const URL_CONFIRM_RESET_PASSWORD  = "/confirm-reset-password/"

export const URL_SEANCE = "/seances/";
export const URL_SEANCE_BY_ID = (id) => {
    return `/seances/${id}/`
}
export const URL_TOTAL_PRICE_BY_SEANCE_ID = (seance_id) => {
    return `/total_price/${seance_id}`
}
export const URL_SEANCE_BY_CODE_ACCES = (code_acces) => {
    return `/seances_anonymous/code_acces/${code_acces}/`;
}
export const URL_ANONYMOUS_SEANCE_BY_ID = (id) => {
    return `/seances_anonymous/${id}/`;
}
export const URL_START_SEANCE_BY_ID = (id) => {
    return `/seances/${id}/start_seance/`;
}
export const URL_STOP_SEANCE_BY_ID = (id) => {
    return `/seances/${id}/stop_seance/`;
}
export const URL_TOOGLE_NEED_PAYMENT_METHOD_SEANCE_BY_ID = (id) => {
    return `/seances/${id}/toggle_need_payment_method/`;
}
export const URL_COMMANDE = "/commandes/";

export const URL_KRACH = "/krachs/";
export const URL_KRACH_BY_ID = (id) => {
    return `/krachs/${id}/`;
}
export const URL_STOP_KRACH_BY_ID = (id) => {
    return `/krachs/${id}/stop/`;
}
export const URL_KRACH_BY_SEANCE = (id) => {
    return `/krachs/seance/${id}/`;
}
export const URL_KRACH_RUNNING_BY_SEANCE = (id) => {
    return `/krachs/seance/${id}/running/`;
}
export const URL_PRICE_HISTORY_ANONYMOUS_BY_SEANCE = (id) => {
    return `/price_histories/seance/${id}/`;
}
export const URL_PRICE_HISTORY_ANONYMOUS_BY_DRINK = (id) => {
    return `/price_history/drink/${id}`
}
export const URL_EXPORT_DATA_BY_SEANCE_ID = (id) => {
    return `/export_datas/seance/${id}`;
}
export const URL_DRINK_ANONYMOUS = (seance_id, drink_id) => {
    return `/drinks_anonymous/seance/${seance_id}/drink/${drink_id}/`
}

export const URL_NEWS_BY_SESSION_ID = (session_id) => {
    return `/news/${session_id}/`
}

export const URL_CATEGORY = "/category";
